import { GrainUsageTypeEnum } from '@/common/constants';
import { ComboboxControl } from '@/components/controls/combobox-control';
import { InputControl } from '@/components/controls/input-control';
import SelectControl from '@/components/controls/select-control';
import { Heading } from '@/components/heading/Heading';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import { cn } from '@/lib/utils';
import { CircleCheck } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePartiesGrain } from '../../hooks';
import usePartyGrainStore from '../../store/usePartyGrainStore';

export const PartiesGrainAction: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { slug, form, onSubmit } = usePartiesGrain();
  const {
    isCreateLoading,
    isUpdateLoading,
    storageTypesByGoods,
    storageTypesBySeed,
    classListByGrain,
    plantsGrain,
    cropTypesByPlant,
    cropGenerationsByPlantId,
  } = usePartyGrainStore();
  const activeTab = searchParams.get('activeTab');

  return (
    <div className="flex flex-col py-8 px-10 w-full">
      <div className="flex-h-center-between mb-6">
        <Heading
          title={
            slug
              ? activeTab === GrainUsageTypeEnum.SEED
                ? 'edit.parties'
                : 'edit.place'
              : activeTab === GrainUsageTypeEnum.SEED
                ? 'add.parties'
                : 'add.places'
          }
          back
          onBack={() => navigate(-1)}
        />
      </div>
      <Form {...form}>
        <form
          onSubmit={onSubmit}
          className={cn('flex flex-col items-end space-y-5')}
        >
          <div className="grid grid-cols-10 gap-4 w-full">
            <InputControl
              control={form.control as any}
              name="place_number"
              label={t('place.number')}
              placeholder={t('place.number')}
              className="col-span-2"
            />
            {activeTab === GrainUsageTypeEnum.SEED ? (
              <InputControl
                control={form.control as any}
                name="party_number"
                label={t('party.number')}
                placeholder={t('choose.data')}
                className="col-span-2"
              />
            ) : (
              <InputControl
                control={form.control as any}
                name="place_name"
                label={t('enter.place.name')}
                placeholder={t('choose.data')}
                className="col-span-2"
              />
            )}

            <SelectControl
              name="plant_id"
              label={t('type.of.crop')}
              options={plantsGrain}
              control={form.control}
              placeholder={t('choose.data')}
              className="col-span-3"
            />
            <ComboboxControl
              name="crop_type_id"
              label={t('selection.type')}
              options={cropTypesByPlant}
              control={form.control as any}
              placeholder={t('choose.data')}
              className="col-span-3"
            />
            {activeTab === GrainUsageTypeEnum.SEED && (
              <SelectControl
                name="crop_generation_id"
                label={t('generation')}
                options={cropGenerationsByPlantId}
                control={form.control}
                placeholder={t('choose.data')}
                className="col-span-2"
              />
            )}
            <SelectControl
              name="class"
              label={t('industrial.grade')}
              options={classListByGrain}
              control={form.control}
              placeholder={t('choose.data')}
              className="col-span-2"
            />

            <InputControl
              control={form.control}
              name="capacity"
              label={t('capacity.kg')}
              placeholder={t('enter.capacity')}
              className="col-span-2"
              isNumber
            />
            <SelectControl
              name="storage_type"
              label="Saqlash turi"
              options={
                activeTab === GrainUsageTypeEnum.SEED
                  ? storageTypesBySeed
                  : storageTypesByGoods
              }
              control={form.control}
              placeholder={t('choose.data')}
              disabled={activeTab === GrainUsageTypeEnum.SEED}
              className="col-span-2"
            />
          </div>

          <Button type="submit" isLoading={isCreateLoading || isUpdateLoading}>
            <CircleCheck color="white" size="18" />
            {t('save')}
          </Button>
        </form>
      </Form>
    </div>
  );
};
